import React, { useState, useEffect } from 'react';
import { Button, Spin, Badge, Divider } from "antd";
import "./index.scss";
import "./home.scss";
import { useNavigate } from "react-router-dom";
import { getRequest } from '../../api/http';
import { useStore } from '../../store';
import userServiceApi from "../../api/userServiceApi";
import { setFullPendingCount, setHubPendingCount, setFullDeleteReviewCount, setHubDeleteReviewCount, setSponsorList } from '../../store/actions';
import { rotateArrayByOne } from '../../utils';
import ImageSliderNew from '../slider/ImageSliderNew';
import { PARTNER_TYPE } from '../constants';
import { getAuthToken } from '../../utils/helper';

export default function Home({ partnerData }) {
    const navigate = useNavigate();
    const { dispatch } = useStore();
    const salesType = partnerData && Object?.keys(partnerData)?.length ? partnerData?.salesType?.toLowerCase() : "";
    const partnerType = partnerData && Object?.keys(partnerData)?.length ? partnerData?.partnerType?.toLowerCase() : "";
    const partnername = sessionStorage.getItem("OrgName");
    const partnerId = sessionStorage.getItem("partnerId");

    const [carouselData, setCarouselData] = useState([]);
    const [carouselLoader, setCarouselLoader] = useState(true);

    const [overview, setOverview] = useState();
    const [overviewLoader, setOverviewLoader] = useState(true);

    // const [sponsorData, setSponsorData] = useState([]);
    const [sponsorLoader, setSponsorLoader] = useState(true);
    const [sponsorDataFirstLine, setFirstLine] = useState([]);
    const [sponsorDataSecondLine, setSecondLine] = useState([]);

    const getCarouselData = async () => {
        try {
            const headers = {
                Authorization: `Bearer ${getAuthToken()}`,
            };
            const response = await getRequest(userServiceApi.getCarousel(), headers);
            if (response) {
                const {data} = response
                if(data?.length){
                    setCarouselData(rotateArrayByOne(data))   
                }
                setCarouselLoader(false);
                
            }
        } catch (error) {
            // console.log(error);
        }
    };

    const getLogoData = async (partnername) => {
        try {
            const headers = {
                Authorization: `Bearer ${getAuthToken()}`,
            };
            const response = await getRequest(
                userServiceApi.getPartnerLogo(partnername),
                headers
            );
            if (response) {
                // console.log(response)
                // setSponsorData(response.data);
                dispatch(setSponsorList(response.data));
                setFirstLine(response.data.slice(0, Math.min(response.data.length, 6)));
                setSecondLine(response.data.slice(6, Math.min(response.data.length, 11)));
                setSponsorLoader(false);
            }
        } catch (error) {
        }
    };

    const getMembersOverview = async (partnerId) => {
        try {
            const res = await getRequest(userServiceApi.getPartnerMembersOverview(partnerId));
            if (res) {
                // console.log("partner overview", res)
                let temp = {
                    fullTotal: res?.data.orgTotalCountFullMem,
                    fullPending: res?.data?.orgPendingCountFullMem,
                    fullDeleteReviews: res?.data?.deleteReviewCountFullMem,
                    fullMicrosites: res?.data?.micrositeTotalCountFullMem,
                    hubTotal: res?.data.orgTotalCountHubMem,
                    hubPending: res?.data?.orgPendingCountHubMem,
                    hubDeleteReviews: res?.data?.deleteReviewCountHubMem,
                    hubMicrosites: res?.data?.micrositeTotalCountHubMem,
                    fullMembSitePending: res?.data?.micrositePendingCountFullMem,
                    hubMembSitePending: res?.data?.micrositePendingCountHubMem,
                }
                setOverview(temp);
                sessionStorage.setItem("hubPending", temp?.hubPending);
                sessionStorage.setItem("fullPending", temp?.fullPending);
                sessionStorage.setItem("fullMembSitePending", temp?.fullMembSitePending);
                sessionStorage.setItem("hubMembSitePending", temp?.hubMembSitePending);
                setOverviewLoader(false);
                dispatch(setFullPendingCount(res?.data?.orgPendingCountFullMem));
                // console.log("res?.data?.orgPendingCountHubMem", res?.data?.orgPendingCountHubMem)
                dispatch(setHubPendingCount(res?.data?.orgPendingCountHubMem));
                dispatch(setFullDeleteReviewCount(res?.data?.deleteReviewCountFullMem));
                dispatch(setHubDeleteReviewCount(res?.data?.deleteReviewCountHubMem));
            }
        } catch (error) {

        }
    }

    useEffect(() => {
        if (partnername) {
            getLogoData(partnername);
        }
        getCarouselData();
        getMembersOverview(partnerId);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <div className="main-container">
            <div className="row-one">
                <div className={`carousel-container border-shadow-class ${salesType === "retail" ? "carousel-container-retail" : ""}`}>
                    {!carouselLoader ? (
                        <>
                            <div className="container-header">
                                <p className='header carousel-header'>Home page carousel</p>
                            </div>
                            {/* <ImageSlider data={carouselData} /> */}
                            <ImageSliderNew data={carouselData} />
                            <div className="approve-edit-btn">
                                <Button onClick={() => navigate('/carousel')}>Add/Edit Carousel</Button>
                            </div>
                        </>
                    ) : (
                        <div className="data-loader">
                            <Spin tip="Loading" size="large" />
                        </div>
                    )}
                </div>
                <div className={`members-overview-container border-shadow-class ${salesType === "retail" ? "members-overview-container-retail" : ""}`}>
                    {!overviewLoader && overview ? (
                        <>
                            <div className="full-members-overview">
                                <div className="member-type-header">
                                    <p className='container-header'>{PARTNER_TYPE[partnerType?.toLowerCase()] || "Members"}</p>
                                </div>
                                <div className="member-orgs">
                                    <p className='total-orgs'>{overview?.fullTotal}</p>
                                    <div className="org-label-action">
                                        <div className='headingWithLink'>
                                            <div className='head org' onClick={() => navigate('/full-members',{ state: { pendingCount: overview?.fullPending } })}>organisations</div>
                                            {/* <div className='link' onClick={() => navigate('/full-members')}>View all</div> */}
                                        </div>
                                        {/* <a className='org-label view-label ' onClick={() => navigate('/full-members')}>View all organisations</a> */}
                                        {/* <p className='org-view' onClick={() => navigate('/full-members')}>view all</p> */}
                                    </div>
                                </div>
                                <Divider className='members-orgs-stats-divider' />
                                {/* <div className="member-microsites">
                                    <p className='total-microsites'>{overview?.fullMicrosites}</p>
                                    <p className='org-label'>Sites</p>
                                </div>
                                <Divider className='members-orgs-stats-divider' /> */}
                                <div className="member-actions">
                                    <Badge className='member-action-badge' count={overview?.fullPending} showZero overflowCount={20}>
                                        <Button className='action-btns' onClick={() => navigate('/full-pending', { state: { page: "home" } })}>Pending approvals</Button>
                                    </Badge>
                                    <Badge className='member-action-badge' count={overview?.fullDeleteReviews} showZero overflowCount={20}>
                                        <Button className='action-btns' onClick={() => navigate('/full-delete-reviews', { state: { page: "home" } })}>Review requests</Button>
                                    </Badge>
                                </div>
                            </div>


                           {(salesType !== "retail")  && (
                            <>
                                <Divider type="vertical" className="divider member-divider" />
                                <div className="hub-members-overview">
                                    <div className="member-type-header">
                                        <p className='container-header'>Leads</p>
                                    </div>
                                    <div className="member-orgs">
                                        <p className='total-orgs'>{overview?.hubTotal}</p>
                                        <div className="org-label-action">
                                            {/* <a className='org-label view-label' onClick={() => navigate('/hub-members')}>View all organisations</a> */}
                                            <div className='headingWithLink'>
                                                <div className='head' onClick={() => navigate('/hub-members',{ state: { hubPendingcount: overview?.hubPending } })}>organisations</div>
                                                {/* <div className='link' onClick={() => navigate('/hub-members')}>View all</div> */}
                                            </div>

                                            {/* <p className='org-label'>Organisations</p> */}
                                            {/* <p className='org-view' onClick={() => navigate('/hub-members')}>view all</p> */}
                                        </div>
                                    </div>
                                    <Divider className='members-orgs-stats-divider' />
                                    {/* <div className="member-microsites">
                                        <p className='total-microsites'>{overview?.hubMicrosites}</p>
                                        <p className='org-label'>Sites</p>
                                    </div>
                                    <Divider className='members-orgs-stats-divider' /> */}
                                    <div className="member-actions">
                                        <Badge className='member-action-badge' count={overview?.hubPending} showZero overflowCount={20}>
                                            <Button className='action-btns' onClick={() => navigate('/hub-pending', { state: { page: "home" } })}>Pending approvals</Button>
                                        </Badge>
                                        <Badge className='member-action-badge' count={overview?.hubDeleteReviews} showZero overflowCount={20}>
                                            <Button className='action-btns' onClick={() => navigate('/hub-delete-reviews', { state: { page: "home" } })}>Review requests</Button>
                                        </Badge>
                                    </div>
                                </div>
                            </>)}
                        </>
                    ) : (
                        <div className="data-loader">
                            <Spin tip="Loading" size="large" />
                        </div>
                    )}
                </div>
            </div>
            {!sponsorLoader ? (
                <div className="row-two">
                    <div className="sponsor-container border-shadow-class">
                        <div className="container-header">
                            <p className='header'>Sponsors</p>
                            <div className="add-btn">
                                <Button onClick={() => navigate('/sponsors')}>View all</Button>
                                <Button onClick={() => navigate('/add-sponsors', { state: { data: "", page: "home" } })}>Add Sponsors</Button>
                            </div>
                        </div>
                        {sponsorDataFirstLine && sponsorDataFirstLine.length > 0 ? (
                            <div className="sponsor-list">
                                {sponsorDataSecondLine.length > 0 ?
                                    sponsorDataFirstLine.map((sponsor) => (
                                        <div className="sponsor-div">
                                            {/* {console.log("sponsor", sponsor)} */}
                                            <div className="sponsor-logo-div">
                                                <img className='sponsor-logo' src={sponsor?.mediaLink?.url} alt="" />
                                            </div>
                                            {/* <div className="sponsor-text-div">
                                                <p>{sponsor.description}</p>
                                            </div> */}
                                        </div>
                                    ))
                                    : sponsorDataFirstLine.slice(0, Math.min(sponsorDataFirstLine.length, 5)).map((sponsor) => (
                                        <div className="sponsor-div">
                                            {/* {console.log("sponsor", sponsor)} */}
                                            <div className="sponsor-logo-div">
                                                <img className='sponsor-logo' src={sponsor?.mediaLink?.url} alt="" />
                                            </div>
                                            {/* <div className="sponsor-text-div">
                                                <p>{sponsor.description}</p>
                                            </div> */}
                                        </div>
                                    ))
                                }
                                {/* {sponsorDataFirstLine.length < 6 || sponsorDataSecondLine.length === 0 ? (
                                    <div className="sponsor-div">
                                        <div className="add-btn">
                                            <Button onClick={() => navigate('/sponsors')}>View all</Button>
                                        </div>
                                    </div>
                                ) : (
                                    <></>
                                )} */}
                            </div>
                        ) : (
                           <div className="noDataSvailable">No Sponsors available</div>
                        )}
                        {sponsorDataSecondLine && sponsorDataSecondLine.length > 0 ? (
                            <>
                                <Divider className='sponsors-divider' />
                                <div className="sponsor-list">
                                    {sponsorDataSecondLine.map((sponsor) => (
                                        <div className="sponsor-div">
                                            {/* {console.log("sponsor", sponsor)} */}
                                            <div className="sponsor-logo-div">
                                                <img className='sponsor-logo' src={sponsor?.mediaLink?.url} alt="" />
                                            </div>
                                            {/* <div className="sponsor-text-div">
                                                <p>{sponsor.description}</p>
                                            </div> */}
                                        </div>
                                    ))}
                                    <div className="sponsor-div">
                                        {/* {console.log("sponsor", sponsor)} */}
                                        <div className="view-all">
                                            <p onClick={() => navigate('/sponsors')}>View all</p>
                                        </div>
                                    </div>
                                </div>
                            </>
                        ) : (
                           <></>
                        )}
                    </div>
                </div>
            ) : (
                <div className="row-two">
                    <div className="sponsor-container border-shadow-class">
                        <div className="container-header">
                            <p className='header'>Sponsors</p>
                            {/* <div className="add-btn">
                                <Button onClick={() => navigate('/add-sponsors', { state: { data: "", page: "home" } })}>Add Sponsors</Button>
                            </div> */}
                        </div>
                        <div className="data-loader" style={{ marginTop: "0px" }}>
                            <Spin tip="Loading" size="large" />
                        </div>
                    </div>
                </div>
            )}
        </div>
    )
}
